import React, { useState } from 'react';
import '../styles/ChatSidePanel.css';
import { Button, IconButton, SmallCompCard } from './';
import { colour } from '../styles/GlobalStyles';
import { ChevronWide } from '../assets/icons';
import { Download04Icon } from 'hugeicons-react';
import { cloudFunctionV2 } from '../functions';

function ChatSidePanel(props) {
    const comps = props.comps;
    const showScrollableImages = props.showScrollableImages;
    const toggleSelectedComp = props.toggleSelectedComp;
    const subjectProperty = props.subjectProperty;
    const countyId = props.countyId;
    const userId = props.userId;
    const [loading, setLoading] = useState(false);

    const togglePanel = () => {

    };

    const downloadProperties = async() => {
        setLoading(true);
        const url = process.env.REACT_APP_GENERATE_SPREADSHEET;
        const params = {
            userId: userId,
            countyId: countyId,
            subjectProperty: subjectProperty,
            comparables: comps,
            downloadData: false
        };

        const newWindow = window.open("", "_blank");
        const queryData = await cloudFunctionV2(url, params);
        if ( queryData.status === 200 ) {
            if ( newWindow === null ) {
                window.open(queryData.data, "_blank");
                newWindow.close();
            }
            else {
                newWindow.location.href = queryData.data;
            }
        }
        else {
            console.log("Error: ", queryData.error);
        }
        setLoading(false);
    };

    return (
        <div className="chat-side-panel-container">
            <div className="chat-side-panel-icon-container">
                <IconButton
                    size="medium"
                    icon={<ChevronWide fill={colour.gray07} className="rotate-90-negative" />}
                    disabled={false}
                    clickFunc={() => togglePanel()}
                    standardIcon={false}
                    background={true}
                    bgType={"white"}
                    contextTooltip={false}
                    contextTooltipBG={null}
                    contextTooltipText={null}
                    customClass={null}
                />
            </div>
            <div className="chat-side-panel-inner-container">
                {
                    comps.map((item, index) =>
                        <SmallCompCard
                            property={item}
                            closeCompCard={null}
                            key={index}
                            selected={true}
                            addSelectedComp={toggleSelectedComp}
                            overlay={true}
                            showScrollableImages={showScrollableImages}
                            slideshow={false}
                        />
                    )
                }
            </div>
            {
                comps.length > 0 &&
                <div className="chat-side-panel-button-container">
                    <Button
                        buttonType="primary-button"
                        size="large"
                        text={"Download CSV"}
                        cta={() => downloadProperties()}
                        disabled={loading}
                        leftIcon={null}
                        leftIconClass=""
                        rightIcon={<Download04Icon color={colour.gray00} size={16} />}
                        rightIconClass=""
                        alt=""
                        standardIcon={false}
                        badge={false}
                        badgeVal={null}
                        badgeBG={null}
                        buttonRef={null}
                        spinner={false}
                    />
                </div>
            }
        </div>
    )
};

export default ChatSidePanel;